module.exports = __webpack_public_path__ + "static/img/service-banner.c398fc78.png";